<template>
  <div class="addCompany sirui-search">
    <!--新增公司-->
    <el-dialog
      :title="$t('company.insertCompany')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-tabs type="border-card">
        <el-tab-pane :label="$t('company.companyInfo')">
          <el-form
            label-width="80px"
            ref="companyDialog"
            :label-position="'right'"
            :rules="rules"
            :model="addInfo"
          >
            <el-form-item :label="$t('company.detail.companyName')" prop="createCompanyName">
              <el-input
                v-model.trim="addInfo.createCompanyName"
                class="inputWidth"
                clearable
                :maxlength="64"
                :placeholder="$t('company.companyNamePlaceholder')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('company.detail.companyAddress')" prop="companyAddress">
              <el-input
                v-model="addInfo.companyAddress"
                class="inputWidth"
                clearable
                :maxlength="256"
                :placeholder="$t('company.companyAddressPlaceholder')"
              ></el-input>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('company.detail.companyNational')" prop="companyNational">
                  <el-select
                    v-model="addInfo.companyNational"
                    filterable
                    :placeholder="$t('company.companyNationalPlaceholder')"
                    @change="selectCountry"
                    clearable
                  >
                    <el-option
                      v-for="item in country"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="propClass"
                  :label="$t('company.detail.creditCode')"
                  prop="creditCode"
                >
                  <el-input
                    v-model="addInfo.creditCode"
                    class="inputWidth"
                    clearable
                    :maxlength="32"
                    :placeholder="$t('company.creditCodePlaceholder')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item :label="$t('company.detail.companyIndex')" prop="sortOrder">
              <el-input-number
                v-model="addInfo.sortOrder"
                controls-position="right"
                class="inputWidth"
                :min="0"
                :max="999"
              ></el-input-number>
            </el-form-item>
          </el-form>
          <div class="department-content">{{ this.$t('company.departmentTitle') }}</div>
          <!--新增/删除按钮-->
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button
                type="primary"
                icon="el-icon-plus"
                class="vxe-btn-primary"
                @click="insertEvent()"
                >{{ $t('xTable.insert') }}</vxe-button
              >
              <vxe-button
                type="primary"
                icon="el-icon-delete"
                class="vxe-btn-delete"
                @click="deleteEvent()"
                >{{ $t('xTable.delete') }}</vxe-button
              >
            </template>
          </vxe-toolbar>
          <!---可编辑表格-->
          <vxe-table
            border
            size="mini"
            show-overflow
            show-header-overflow
            ref="xTable"
            class="edit-table"
            :height="80"
            :max-height="180"
            :data="tableData"
            :edit-rules="validRules"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
            @cell-click="cellClick"
          >
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column type="seq" width="50" :title="$t('table.index')"></vxe-table-column>
            <vxe-table-column
              field="createDepartmentName"
              :title="$t('company.table.departmentName')"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="scope.row.createDepartmentName"
                  :placeholder="$t('company.departmentPlaceholder')"
                  @change="$refs.xTable.updateStatus(scope)"
                ></el-input>
              </template>
              <template v-slot="{ row }">{{ row.createDepartmentName }}</template>
            </vxe-table-column>

            <vxe-table-column
              field="receiptClaimMode"
              :title="$t('company.detail.receiptClaimMode')"
              :edit-render="{ type: 'default' }"
            >
              <template v-slot:edit="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="getSelectLabel(scope.row.receiptClaimMode, receiptClaimModeList) + ''"
                  placement="bottom"
                  :disabled="
                    scope.row.receiptClaimMode == '' || scope.row.receiptClaimMode == null
                      ? true
                      : false
                  "
                >
                  <el-select
                    style="width: 100%"
                    v-model="scope.row.receiptClaimMode"
                    filterable
                    @change="$refs.xTable.updateStatus(scope)"
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item in receiptClaimModeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </template>
              <template v-slot="{ row }">{{
                getSelectLabel(row.receiptClaimMode, receiptClaimModeList)
              }}</template>
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('company.system')"></el-tab-pane>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/company.js';
  // import BASE_API from '@/api/dataBase.js';
  // import { isEqual } from '@/common/js/util';
  // import * as rule from '@/pages/masterData/outsidePrice/rules';
  import XEUtils from 'xe-utils';
  export default {
    name: 'addCompany',
    data() {
      var specialValidate = (rule, value, callback) => {
        var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
        if (value != null && value.match(reg)) {
          callback(new Error(this.$t('menu.emoticons')));
        } else {
          callback();
        }
      };
      return {
        dialogAdd: false,
        detail: {},
        loading: false,
        addInfo: {
          createCompanyName: null,
          companyAddress: null,
          companyNational: null,
          creditCode: null,
          sortOrder: 0,
        },
        tableData: [],
        allDepartmentList: [], //查询所有部门下拉
        createDepartmentList: [], //根据输入匹配出符合的部门列表
        rules: {
          createCompanyName: [
            {
              required: true,
              message: this.$t('company.companyNameNotEmpty'),
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          companyAddress: [{ validator: specialValidate, trigger: ['blur', 'change'] }],
          companyNational: [
            {
              required: true,
              message: this.$t('company.companyNationalNotEmpty'),
              trigger: 'change',
            },
          ],
          creditCode: [
            {
              required: true,
              message: this.$t('company.creditCodeNotEmpty'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        },
      };
    },
    props: {
      receiptClaimModeList: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取定价规则值
        country(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
      validRules() {
        return {
          createDepartmentName: [
            { required: true, message: this.$t('company.departmentNameNotEmpty') },
          ],
        };
      },
    },
    methods: {
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      openDialog(flag, detail) {
        this.detail = detail;
        if (this.$refs['companyDialog']) {
          this.$refs['companyDialog'].resetFields();
        }
        this.tableData = [];
        // for (let i = 0; i < 5; i++) {
        //   this.tableData.push({
        //     createDepartmentCode: null
        //   });
        // }
        //查询所有部门
        this.initDepartment();
        this.loading = false;
        this.dialogAdd = flag;
      },
      //初始化部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
        this.$axios.post(API.GET_DEPARTMENT_LIST_API, params).then((res) => {
          if (0 == res.data.code) {
            this.allDepartmentList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取下拉数据
      remoteMethod(query) {
        if (query != '') {
          const params = {
            tenantCode: this.userInfo.userInfo.tenantCode,
            createDepartmentName: query,
          };
          this.$axios.post(API.GET_DEPARTMENT_LIST_API, params).then((res) => {
            if (0 == res.data.code) {
              this.createDepartmentList = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        } else {
          this.createDepartmentList = [];
        }
      },
      selectCountry() {
        if (
          this.addInfo.companyNational == 'CN' ||
          this.addInfo.companyNational == 'MO' ||
          this.addInfo.companyNational == 'HK' ||
          this.addInfo.companyNational == 'ZH'
        ) {
          this.rules.creditCode[0].required = true;
        } else {
          this.rules.creditCode[0].required = false;
        }
      },
      //新增一行
      insertEvent() {
        this.$refs.xTable.validate().then(() => {
          this.createDepartmentList = [];
          const record = {
            createDepartmentName: null,
            receiptClaimMode: 'C',
          };
          this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
        });
        // this.$refs.xTable.validate(valid => {
        //   if (valid) {
        //     this.createDepartmentList = [];
        //     const record = {
        //       createDepartmentName: null,
        //       receiptClaimMode:"C"
        //     };
        //     this.$refs.xTable
        //       .insert(record)
        //       .then(({ row }) => this.$refs.xTable.setActiveRow(row));
        //   }
        // });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //点击行
      cellClick() {
        this.createDepartmentList = this.allDepartmentList;
      },
      //根据code匹配出name
      // getSelectLabel(
      //   value,
      //   valueProp = "createDepartmentCode",
      //   labelField = "createDepartmentName"
      // ) {
      //   let item = XEUtils.find(
      //     this.allDepartmentList,
      //     item => item[valueProp] === value
      //   );
      //   return item ? item[labelField] + "(" + value + ")" : null;
      // },
      //保存
      addSure() {
        // let xTableValidFlag = true;
        let createDepartmentList = [];
        let status = false;
        //1.校验表格
        this.$refs.xTable.validate().then(() => {
          const tableList = this.$refs.xTable.getTableData().fullData;
          for (let i = 0; i < tableList.length; i++) {
            createDepartmentList.push({
              createDepartmentName: tableList[i].createDepartmentName,
              receiptClaimMode: tableList[i].receiptClaimMode,
            });
          }
          //2.判断是否有重复的数据
          if (createDepartmentList.length > 1) {
            let start = 1;
            for (let n = 0; n < createDepartmentList.length; n++) {
              if (status) {
                break;
              }
              for (start; start < createDepartmentList.length; start++) {
                if (n != start) {
                  // status = isEqual(
                  //   createDepartmentList[n],
                  //   createDepartmentList[start],
                  //   "createDepartmentName"
                  // );
                  if (tableList[n].createDepartmentName == tableList[start].createDepartmentName) {
                    status = true;
                    if (status) {
                      this.$message({
                        showClose: true,
                        message: this.$t('company.departmentSameData'),
                        type: 'error',
                      });
                      return;
                    }
                  }
                }
              }
              start = n;
            }
          }
          //3.校验form表单
          this.$refs['companyDialog'].validate((valid) => {
            if (valid && !this.loading) {
              this.loading = true;
              this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
              this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
              this.addInfo.companyName = this.userInfo.userInfo.companyName;
              this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
              this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
              this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
              // this.addInfo.createDepartmentList = createDepartmentList.length == 0 ? null : JSON.stringify(createDepartmentList);
              this.addInfo.createDepartmentList = createDepartmentList;
              this.$axios.post(API.ADD_COMPANY_API, this.addInfo).then((res) => {
                this.loading = false;
                if (0 != res.data.code) {
                  this.$alert(res.data.msg);
                } else {
                  this.dialogAdd = false;
                  this.$emit('getData');
                  this.$message({
                    showClose: true,
                    message: res.data.msg || this.$t('message.success'),
                    type: 'success',
                  });
                }
              });
            } else {
              return false;
            }
          });
        });
        // this.$refs.xTable.validate(xTableValid => {
        //   xTableValidFlag = xTableValid;
        //   if (xTableValid) {
        //     const tableList = this.$refs.xTable.getTableData().fullData;
        //     for (let i = 0; i < tableList.length; i++) {
        //       createDepartmentList.push({
        //         createDepartmentName: tableList[i].createDepartmentName,
        //         receiptClaimMode: tableList[i].receiptClaimMode
        //       });
        //     }
        //     //2.判断是否有重复的数据
        //     if (createDepartmentList.length > 1) {
        //       let start = 1;
        //       for (let n = 0; n < createDepartmentList.length; n++) {
        //         if (status) {
        //           break;
        //         }
        //         for (start; start < createDepartmentList.length; start++) {
        //           if (n != start) {
        //             // status = isEqual(
        //             //   createDepartmentList[n],
        //             //   createDepartmentList[start],
        //             //   "createDepartmentName"
        //             // );
        //             if (tableList[n].createDepartmentName == tableList[start].createDepartmentName) {
        //               status = true
        //               if (status) {
        //                 this.$message({
        //                   showClose: true,
        //                   message: this.$t("company.departmentSameData"),
        //                   type: "error"
        //                 });
        //                 return;
        //               }
        //             }
        //           }
        //         }
        //         start = n;
        //       }
        //     }
        //     //3.校验form表单
        //     this.$refs["companyDialog"].validate(valid => {
        //       if (valid && !this.loading) {
        //         this.loading = true;
        //         this.addInfo.tenantCode = this.userInfo.userInfo.tenantCode;
        //         this.addInfo.companyCode = this.userInfo.userInfo.companyCode;
        //         this.addInfo.companyName = this.userInfo.userInfo.companyName;
        //         this.addInfo.departmentCode = this.userInfo.userInfo.departmentCode;
        //         this.addInfo.departmentName = this.userInfo.userInfo.departmentName;
        //         this.addInfo.belongTenantCode = this.userInfo.userInfo.tenantCode;
        //         // this.addInfo.createDepartmentList = createDepartmentList.length == 0 ? null : JSON.stringify(createDepartmentList);
        //         this.addInfo.createDepartmentList = createDepartmentList;
        //         this.$axios.post(API.ADD_COMPANY_API, this.addInfo).then(res => {
        //           this.loading = false;
        //           if (0 != res.data.code) {
        //             this.$alert(res.data.msg);
        //           } else {
        //             this.dialogAdd = false;
        //             this.$emit("getData");
        //             this.$message({
        //               showClose: true,
        //               message: res.data.msg || this.$t("message.success"),
        //               type: "success"
        //             });
        //           }
        //         });
        //       } else {
        //         return false;
        //       }
        //     });
        //   }
        // });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
    margin-bottom: 10px;
  }
</style>
